function createResizer(gantt, grid){
	return {
		init: function(){},
		doOnRender: function(){}
	};
}

module.exports = createResizer;


//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/grid/grid_resize.gpl.js
// module id = 40
// module chunks = 0